module.exports = __webpack_public_path__ + "static/img/b3.5b48ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/b3.png
// module id = YW5e
// module chunks = 0